import React, {useEffect, useState} from 'react';

// bootstrap
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';

const PrivacyPolicy = (props) => {

    useEffect(() => {

    }, []);

    const [STATE, SETSTATE] = useState(false)

    return (
        <h1>Privacy Policy</h1>
    );
};

export default PrivacyPolicy;